const routes = [
  {
    path: '',
    component: () => import('@/views/provider/proposalHistory/Wrapper.vue'),
    children: [
      {
        path: '/provider/proposalHistory',
        name: 'ServiceProposalHistory',
        component: () =>
          import('@/views/provider/proposalHistory/proposalServiceWrapper.vue'),
      },
      {
        path: '/provider/proposal/evaluator',
        name: 'ServiceProposalEvaluator',
        component: () =>
          import(
            '@/views/provider/proposalHistory/ServiceProposalEvaluator.vue'
          ),
      },
      {
        path: '/provider/proposal/details/:proposalRequestId',
        name: 'ServiceProposalDetails',
        component: () =>
          import('@/views/provider/proposalHistory/ServiceProposalDetails.vue'),
      },
      {
        path: '/provider/proposal/evaluation/:proposalRequestId/:userId',
        name: 'ServiceProposalEvaluationUser',
        component: () =>
          import(
            '@/views/provider/proposalHistory/ServiceProposalEvaluation.vue'
          ),
      },
      {
        path: '/provider/proposal/evaluation/:proposalRequestId',
        name: 'ServiceProposalEvaluation',
        component: () =>
          import(
            '@/views/provider/proposalHistory/ServiceProposalEvaluation.vue'
          ),
      },
      {
        path:
          '/provider/proposal/:proposalRequestId/evaluator-conflicts-confirmation/:evaluationCenterId',
        name: 'EvaluatorConflictsConfirmation',
        component: () =>
          import(
            '@/views/provider/proposalHistory/EvaluatorConflictsConfirmation.vue'
          ),
      },
      {
        path: '/provider/proposal/addevaluators',
        name: 'proposal-addevaluators',
        component: () =>
          import('@/views/provider/proposalHistory/AddEvaluators'),
      },
      {
        path: '/provider/proposalHistory/tokenHistory',
        name: 'ServiceProposalTokenHistory',
        component: () =>
          import(
            '@/views/provider/proposalHistory/ServiceProposalTokenHistory'
          ),
      },
    ],
  },
];

export default routes;
